module.exports = __webpack_public_path__ + "static/media/vip_values_icon.edbd55c1.svg";